import { IGetUTCOffsetDateTimeAsDayjsParams } from '@aqx-core/common/dayjs/types';

export enum EAppType {
  MOBILE = 'MOBILE',
  PC = 'PC'
}

export enum ESocialMediaType {
  LINKEDIN = 'LINKEDIN',
  TWITTER = 'TWITTER',
  FACEBOOK = 'FACEBOOK',
  INSTAGRAM = 'INSTAGRAM',
  YOUTUBE = 'YOUTUBE',
  QQ = 'QQ',
  WEIBO = 'WEIBO',
  XHS = 'XHS',
  BILIBILI = 'BILIBILI',
  WECHAT = 'WECHAT',
  WHATSAPP = 'WHATSAPP',
  TELEGRAM = 'TELEGRAM'
}

export interface IConvertToDayjsWithOffsetParams
  extends Pick<IGetUTCOffsetDateTimeAsDayjsParams, 'input' | 'keepTime' | 'baseFromOffset'> {}
